/**
 * The "national number" is the 10 digits after +91. That is what the form edits; the backend
 * normalises whatever it receives to E.164, but we send clean input.
 */
export function sanitizeNationalNumber(input: string): string {
  let digits = input.replace(/\D/g, "");
  // Pasted numbers often carry a country code or trunk prefix: +91…, 91…, 0…
  if (digits.length > 10) {
    if (digits.startsWith("91") && digits.length <= 12) digits = digits.slice(2);
    else if (digits.startsWith("0")) digits = digits.slice(1);
  }
  return digits.slice(0, 10);
}

/** An Indian mobile number: 10 digits, starting 6–9. */
export function isValidIndianMobile(nationalNumber: string): boolean {
  return /^[6-9]\d{9}$/.test(nationalNumber);
}

/** 9876543210 -> "+91 ••••••3210" — enough to recognise, not enough to read out. */
export function maskNationalNumber(nationalNumber: string): string {
  return `+91 ${"•".repeat(6)}${nationalNumber.slice(-4)}`;
}
